import { Logger } from '@/services/logger';

enum BffErrorExtensionsCode {
  UNAUTHORIZED_PLATFORM = 'UNAUTHORIZED_PLATFORM',
  INVALID_BASE_DATA = 'INVALID_BASE_DATA',
  INVALID_CONSENTS = 'INVALID_CONSENTS',
  NOT_FOUND_SERVICE = 'NOT_FOUND_SERVICE',
  BAD_REQUEST_PLATFORM = 'BAD_REQUEST_PLATFORM',
}

export type BffError = Error & {
  extensions?: {
    code: BffErrorExtensionsCode;
  };
};

export class UnauthorizedPlatformError extends Error {
  public message = 'Unauthorized Platform Error';
}

export class InvalidBaseDataError extends Error {
  public message = 'Invalid Base Data Error';
}

export class InvalidConsentsError extends Error {
  public message = 'Invalid Consents Error';
}

export class NotFoundError extends Error {
  public message = 'Not found error';
}

export class BadRequestError extends Error {
  public message = 'Bad request error';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleBffError = (error: any) => {
  if (error.extensions?.code === BffErrorExtensionsCode.UNAUTHORIZED_PLATFORM) {
    Logger.logError('Unauthorized Platform', error.message);

    throw new UnauthorizedPlatformError();
  }

  if (error.extensions?.code === BffErrorExtensionsCode.INVALID_BASE_DATA) {
    Logger.logError('Invalid Base Data', error);

    throw new InvalidBaseDataError();
  }

  if (error.extensions?.code === BffErrorExtensionsCode.INVALID_CONSENTS) {
    Logger.logError('Invalid Consents', error);

    throw new InvalidConsentsError();
  }

  if (error.extensions?.code === BffErrorExtensionsCode.NOT_FOUND_SERVICE) {
    Logger.logError('Not Found', error);

    throw new NotFoundError();
  }

  if (error.extensions?.code === BffErrorExtensionsCode.BAD_REQUEST_PLATFORM) {
    Logger.logError('Bad Request', error);

    throw new BadRequestError();
  }

  Logger.logError(`Unknown Error: ${error.extensions?.code}`);

  throw new Error('Unexpected Error fetching BFF');
};
